import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class DokumentiService {
  constructor(private _http: HttpClient) {}

  dohvatiDokumentePoPoslovnici(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'pregled_Dokumenata_Datum_Po_Poslovnici', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSvePoslovnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_Sve_Poslovnice', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuDostavnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jednu_dostavnicu_web', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuOtpremnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'pregled_Dokumenata_Stavke', a)
      .pipe(map((res: any) => res));
  }

  dohvati_otpremnicu_pekartomo_iz_pekara(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_otpremnicu_pekartomo_iz_pekara', a)
      .pipe(map((res: any) => res));
  }

  otpremnica_detalji(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'otpremnica_detalji', a)
      .pipe(map((res: any) => res));
  }

  
}
